import { get } from 'lodash'

type Get = typeof get

export const objectGet: Get = get
